<template>
  <div>
    <div class="footer" v-if="!isCollagePay">
      <ul class="module-nav">
        <li class="server" @click="toService">
          <van-icon class="icon" name="service-o" />
          <span class="font">客服</span>
        </li>
        <li v-if="actType !== 'pintuan'" class="server" @click="shareQRCode">
          <van-icon class="icon" name="share-o" />
          <span class="font">分享</span>
        </li>
        <li class="module-btn get-buy" @click="clickPayWithLog" v-if="secondKill">立即抢购</li>
        <template v-else>
          <!-- 进团开始后,不显示购物车 -->
          <template v-if="isCart && collageStatus !== '进行中' && actType !== 'dengji'">
            <li class="server" @click="toShoppingCar(1)">
              <van-icon class="icon" size="24px" name="cart-o" />
              <i class="num-tag">{{ goodsNum }}</i>
              <span class="font">购物车</span>
            </li>
            <li class="module-btn join-car" @click="toShoppingCar(2)" v-if="goodsNumber !== 0">加入购物车</li>
          </template>
          <!-- 腾讯 和 腾讯APK 虚拟sku 需要用微信登录后购买激活 -->
          <li
            v-if="getTencentAppCodeList.includes(defaultObj.appCode) && $getBrowser() === 'alipay'"
            class="module-btn module-btn--grey"
          >
            请用微信扫码购买
          </li>
          <template v-else-if="collageStatus == '未开始'">
            <li class="module-btn get-buy collageflex" @click="clickPayWithLog">
              <div class="nostardiv">活动未开始</div>
              <div class="normalPay">原价购买</div>
            </li>
          </template>
          <template v-else-if="collageStatus == '进行中'">
            <li class="module-btn module-btn-white" @click="collagepaying">原价购买</li>
            <li class="module-btn get-buy collageflex" @click="clickCollage">发起拼团</li>
          </template>
          <template v-else>
            <li v-if="goodsNumber === 0" class="module-btn module-btn--grey">敬请期待</li>
            <li v-else class="module-btn get-buy" @click="clickPayWithLog">立即购买</li>
          </template>
        </template>
      </ul>
    </div>
    <div class="footer" v-else>
      <ul class="goods-message">
        <li class="count-box">
          <div class="count-x" @click="clickCloseCollage">X</div>
          <div class="count-left">
            <span class="change-count">选择数量</span>
            <span class="color-999">库存{{ goodsNumber }}</span>
          </div>
          <!-- 实物才能选择数量 -->
          <!-- 拼团的时候也要隐藏,点击原价购买才能选择数量 -->
          <div class="num-count">
            <van-stepper integer v-model="selectNumber" @change="collageChangeNum" :min="1" :max="maxCartNumber" />
          </div>
        </li>
      </ul>
      <ul class="module-nav">
        <li class="module-btn get-buy" @click="clickPayOK">立即购买</li>
      </ul>
    </div>
    <div class="darkBG" v-if="isCollagePay"></div>

    <!--  规格  -->
    <!-- v-if="typeBuy != 'skill' || typeBuy != 'tejia'" -->
    <van-popup
      v-model="goodsModel"
      round
      position="bottom"
      v-if="typeBuy != 'skill' || typeBuy != 'tejia' || dengji != 'dengji'"
    >
      <div class="choiceNum">
        <div class="goodsModel">
          <div class="imgMsgs">
            <img class="image" :src="goodsInfo.skuThumb || defaultObj.skuThumb" alt="" />
            <div class="rightPrice">
              <div class="red" v-if="defaultObj.__actPrice">¥{{ defaultObj.__actPrice}}</div>
              <div class="red" v-else>¥{{ defaultObj.sellPrice }}</div>
              <div class="p" v-if="goodsModelsList.modelItems">已选：{{ goodsInfo.goodsModel || '' }}</div>
            </div>
          </div>
        </div>
        <div class="product_tab" v-if="goodsModelsList.modelItems">
          <div class="tab_specs" v-for="(item, index) in goodsModelsList.modelItems" :key="index">
            <div class="title">{{ item.name }}</div>
            <div class="list">
              <div
                class="view"
                v-for="(text, index2) in item.values"
                :key="index2"
                @click="changeSpecs(index, text)"
                :class="addClassSpecs(text) ? 'active' : ''"
              >
                <span class="overflow-auto text">{{ text.name }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="change-num cf">
          <span class="label">选择数量</span>
          <span class="text">
            {{ `${goodsInfo.stockNumber ? `库存${goodsInfo.stockNumber || 0}` : ''}` }}
          </span>
          <van-stepper
            v-if="isShiWu"
            integer
            v-model="goodsInfo.number"
            @change="numberChange"
            :min="1"
            :max="goodsInfo.stockNumber"
            class="goods-stepper"
          />
          <span v-else class="goods-stepper" style="font-size: 14px">1</span>
        </div>
        <!--    选择数量    -->
        <div class="btns" v-if="showBuyNowBtn">
          <div class="buyNowBtn" v-if="isShiWu" @click="addToCart">加入购物车</div>
          <div :class="isShiWu ? 'shiwu' : 'xuni'" class="buyNowBtn" @click="paying">立即购买</div>
        </div>
        <div v-else>
          <div class="buyNowBtn disabled">所选规格已下架</div>
        </div>
      </div>
    </van-popup>

    <van-popup v-model="vipBuyPop" class="vip-buy--pop">
      <div class="title">酷开贴心提示</div>
      <div
        class="content"
        v-if="
          defaultObj.appCode === '1026' ||
          getTencentAppCodeList.includes(defaultObj.appCode) ||
          defaultObj.appCode === '7909'
        "
      >
        请仔细检查您的电视是否为
        <span>{{ appCodeMap[defaultObj.appCode] }}影视源</span>
        <br />
        避免错误购买无法观看～
      </div>
      <div class="content" v-else-if="defaultObj.appCode === '7890'">请下载腾讯云视听极光APP观看~</div>
      <div class="content" v-else>
        请仔细核对所登录的电视帐号，
        <br />
        避免错误购买无法观看～
      </div>
      <div class="prompt-text" @click="clickGoVipBuyTips">
        如何查看电视影视源
        <van-icon class="icon" name="question-o" />
      </div>
      <div class="button" @click="goBuy">已检查，继续购买</div>
    </van-popup>

    <van-popup v-model="sharePicPop">
      <img :src="sharePic" alt="" class="shareImg" />
    </van-popup>

    <commonShare
      @weChatCollage="weChatCollage"
      @shareCollage="shareCollage"
      v-model="shareMode"
      :goodsId="defaultObj.skuId"
      :is-emp="isEmp"
    ></commonShare>
    <ShareRightTopMessage :showShare.sync="showShare"></ShareRightTopMessage>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import commonShare from '@/components/common-share/index.vue'
import ShareRightTopMessage from '@/components/ShareRightTopMessage.vue'
import { shareCollage } from '@/utils/common'

export default {
  components: {
    ShareRightTopMessage,
    commonShare
  },
  props: [
    'defaultObj',
    'activityInfo',
    'goodsNumber',
    'maxCartNumber',
    'typeBuy',
    'collageStatus',
    'actCode',
    'isShiWu',
    'actType'
  ],
  data() {
    return {
      // 拼团的情况下 点击原价购买,要先提示选择数量
      userInfo: this.$service.state.user,
      isCollagePay: false,
      selectNumber: 1,
      appCodeMap: {
        1026: '爱奇艺',
        1028: '腾讯',
        7890: '腾讯APK会员',
        7909: '酷喵'
      },
      vipBuyPop: false,
      isCart: true,
      goodsNum: 0,
      secondKill: false,
      isClickColl: false,
      isGoCollage: false,
      // 只有当商品详情点击立即参团到支付才有值
      groupCode: '',
      shareMode: false,
      showShare: false,
      sharePicPop: false,
      sharePic: '',
      goodsModel: false,
      goodsInfo: this.defaultObj,
      goodsModelsList: {},
      goodsId: '',
      defaultArr: [],
      checkedGoodsId: this.defaultObj.skuId,
      showBuyNowBtn: true,
      empInfo: {
        empNo: null
      }
    }
  },
  watch: {
    defaultObj(val) {
      console.log('watch:::defaultObj', this.defaultObj);
      console.log('watch:::goodsInfo', this.goodsInfo);
      this.goodsId = val.skuId
      this.cartIsHeid()
    },
    activityInfo() {
      this.cartIsHeid()
      // console.log('**************typeBuy', this.typeBuy) //skill tejia
      // console.log('**************actType', this.actType) //miaosha tejia
    },
    goodsNumber() {
      this.cartIsHeid()
    }
  },
  computed: {
    ...mapGetters(['getEmpNo', 'getFromUrl', 'getGoodsData', 'getTencentAppCodeList', 'isFormalEmp']),
    isEmp() {
      return !!this.empInfo.empNo
    },
    ccLogParams() {
      return {
        commodity_id: this.defaultObj.skuId,
        commodity_name: this.defaultObj.title,
        goods_price: this.defaultObj.sellPrice,
        original_price: this.defaultObj.marketPrice,
        commodity_type: this.defaultObj.spuType,
        user_empNo: this.getEmpNo || '',
        frontPageName: this.getFromUrl,
        page_name: '商品详情'
      }
    }
  },
  methods: {
    ...mapMutations(['pushPageList']),
    getShareLink() {
      let link
      const origin = location.origin
      const { applyId, empNo } = this.empInfo
      const fromCode = applyId || empNo
      const pageType = applyId ? 'applyEmp' : 'employee'
      link = `${origin}/ad-link/ccfx?pageType=${pageType}&target=${encodeURIComponent(
        `${origin}/goodsDetail?goodsId=${this.goodsId}`
      )}&fromCode=${fromCode}`
      // console.log('分享连接', link);
      return link
    },
    shareCollage() {
      shareCollage.call(this)
    },
    weChatCollage() {
      let link = this.getShareLink()
      // console.log('weChatCollage 分享连接', link)
      this.$wxSdk({
        title: '分享一个好物给你',
        desc: this.defaultObj.title,
        link: link,
        imgUrl: this.defaultObj.skuThumb
      }).catch((error) => {
        console.log('微信分享失败', error)
      })
      if (this.isEmp) {
        this.$service.growthValueTask({
          taskType: '100702'
        })
      }
      // console.log('期待分享地址', link)
      this.showShare = true
      this.showPop = false
    },
    sharePicShow() {
      this.shareMode = false
    },
    shareQRCode() {
      this.shareMode = true
    },
    clickGoVipBuyTips() {
      const { skuId, appCode } = this.defaultObj
      const { isGoCollage, typeBuy, actCode } = this
      let buyType = 2
      if (isGoCollage) {
        buyType = 4
      } else if (typeBuy === 'skill') {
        buyType = 3
      }
      this.$router.push({
        name: 'vip-buy-tips',
        query: {
          goodsId: skuId,
          appCode: appCode,
          actCode: isGoCollage || typeBuy === 3 ? actCode || '' : '',
          buyType
        }
      })
    },
    // 商品规格
    getGoodsModelList(sn) {
      this.$service
        .getGoodsModels({
          platformCode: true,
          goodsSn: sn
        })
        .then((res) => {
          this.goodsModel = true
          this.goodsModelsList = res.data
          this.goodsInfo = {}
          const _goods = this.goodsModelsList.goodsItems.find((item) => item.goodsId === this.goodsId)
          this.goodsInfo = _goods
          this.goodsInfo.skuId = _goods.goodsId
          this.goodsInfo.stockNumber = _goods.goodsStock
          this.checkedGoodsId = _goods.goodsId
          this.goodsInfo.sellPrice = _goods.shopPrice
          if (this.goodsModelsList.modelItems) {
            for (let i = 0; i < this.goodsModelsList.modelItems.values.length; i++) {
              const item = this.goodsModelsList.modelItems.values[i]
              if (item.id === _goods.propertyIds.toString()) {
                this.defaultArr[i] = item.id
                break
              }
            }
          }
        })
    },
    clickPayWithLog() {
      // 秒杀 特价 不需要弹规格弹窗 直接购买
      if (this.typeBuy === 'skill' || this.typeBuy === 'tejia' || this.actType === 'dengji') {
        this.paying()
      } else {
        this.getGoodsModelList(this.defaultObj.skuSn)
      }
    },
    clickPayOK() {
      this.pushPageList('立即购买-确定')
      // 商详页面view曝光
      this.$constants.submitccLog('partner_mini_page_click', '商品详情点击立即购买-确定', {
        ...this.ccLogParams,
        button_name: '立即购买-确定'
      })
      this.paying()
    },
    clickCloseCollage() {
      this.selectNumber = 1
      this.$emit('collageChangeNum', this.selectNumber)
      this.isCollagePay = false
    },
    collageChangeNum() {
      this.$emit('collageChangeNum', this.selectNumber)
    },
    clickCollage() {
      this.groupCode = ''
      this.isGoCollage = true
      this.isClickColl = true
      this.paying()
    },
    toShoppingCar(type) {
      if (type === 1) {
        // 点击购物车
        // 曝光click
        this.$constants.submitccLog('partner_mini_page_click', '商品详情点击购物车', {
          ...this.ccLogParams,
          button_name: '购物车'
        })
        this.$router.push({ name: 'store-shopping-car' })
      } else {
        // 点击加入购物车
        // 曝光click
        this.$constants.submitccLog('partner_mini_page_click', '商品详情点击加入购物车', {
          ...this.ccLogParams,
          button_name: '加入购物车'
        })
        this.$service
          .inputCartNew({
            items: [
              {
                goodsId: this.defaultObj.skuId,
                num: this.defaultObj.number || 1
              }
            ]
          })
          .then((res) => {
            if (res.code === 200) {
              this.$toast('加入购物车成功！')
              this.getCartList()
            }
          })
      }
    },
    groupPay(groupCode, actCode) {
      this.isGoCollage = true
      this.isClickColl = false
      this.groupCode = groupCode
      this.actCode = actCode
      this.paying()
    },
    collagepaying() {
      // 商详页面view曝光
      this.pushPageList('立即购买')
      this.$constants.submitccLog('partner_mini_page_click', '商品详情点击立即购买', {
        ...this.ccLogParams,
        button_name: '立即购买'
      })
      if (this.isShiWu) {
        this.isCollagePay = true
      } else {
        // 虚拟产品不需要显示数量
        this.paying()
      }
    },
    // 立即购买
    paying() {
      if (this.goodsNumber === 0) {
        return this.$toast('商品已售罄')
      }
      if (this.defaultObj.spuType === 1) {
        this.goBuy()
      } else {
        this.vipBuyPop = true
      }
    },
    goBuy() {
      const { number, spuType, skuId, virtualRights } = this.defaultObj
      let appCode = ''
      if (virtualRights) {
        appCode = virtualRights.appCode
      }
      let type = 2
      if (this.isGoCollage) {
        type = 4
      } else if (this.typeBuy === 'skill') {
        type = 3
      }
      let isPaying = spuType === 1
      this.$router.push({
        name: isPaying ? 'paying' : 'account-selection',
        query: {
          number: number === undefined ? 1 : number,
          goodsId: skuId,
          buyType: type,
          // appcode 尽量不要用,在分享后的连接带上了会引起重复登录问题
          appCode: isPaying ? undefined : this.defaultObj.virtualRights.appCode,
          // 如果是用户手动点击的拼团,则是新建不要传入groupcode
          groupCode: this.isClickColl ? undefined : this.groupCode,
          actCode: this.isGoCollage || type === 3 ? this.actCode || '' : ''
        }
      })
    },
    // 客服中心
    toService() {
      this.$constants.submitccLog('partner_mini_page_click', '商品详情点击客服', {
        ...this.ccLogParams,
        button_name: '客服'
      })
      this.$service.getLive({ goodsId: this.defaultObj.skuId }).then((res) => {
        window.location.href = res.data
      })
    },
    cartIsHeid() {
      const goodsClassify = this.defaultObj.spuType
      const activityInfo = this.activityInfo
      this.secondKill = false
      this.isCart = goodsClassify === 1
      // 不管什么商品 秒杀/特价的时候不能加购物车
      // goodsClassify === 0 || goodsClassify === 1 || goodsClassify === 2 || goodsClassify === 3 || goodsClassify === 4 || goodsClassify === 5
      if (this.typeBuy === 'skill' || this.typeBuy === 'tejia') {
        activityInfo.forEach((element) => {
          if (element.actType === 5 || element.actType === 4) {
            const nowDate = +new Date()
            if (nowDate > element.actPromotion.startTime * 1000 && nowDate < element.actPromotion.endTime * 1000) {
              // 进行中
              this.isCart = false
              this.secondKill = true
              this.actCode = element.actPromotion.actCode
            }
          }
        })
      }
    },
    // 购物车的数量
    getCartList() {
      this.$service.getCartListNew().then((res) => {
        this.goodsNum = res.data.totalCount
      })
    },
    // 规格切换
    changeSpecs(i, p) {
      this.defaultArr[i] = p.id
      this.goodsInfo = {}
      this.goodsModelsList.goodsItems.forEach((item) => {
        if (item.propertyIds.toString() === this.defaultArr.toString()) {
          this.goodsInfo = item
          this.goodsInfo.skuId = item.goodsId
          this.goodsInfo.stockNumber = item.goodsStock
          this.checkedGoodsId = item.goodsId
          this.goodsInfo.sellPrice = item.shopPrice
        }
      })
      this.showBuyNowBtn = JSON.stringify(this.goodsInfo) !== '{}'
      if (this.goodsInfo.goodsId) {
        this.$emit('changeTap', this.goodsInfo)
      }
    },
    addClassSpecs(def) {
      return this.defaultArr.includes(def.id)
    },
    numberChange(value) {
      this.defaultObj.number = value
    },
    addToCart() {
      if (this.goodsInfo.goodsId || !this.goodsModelsList.modelItems) {
        this.$service
          .inputCartNew({
            items: [
              {
                goodsId: this.goodsInfo.goodsId,
                num: this.goodsInfo.number || 1
              }
            ]
          })
          .then((res) => {
            if (res.code === 200) {
              this.$toast('加入购物车成功！')
              this.getCartList()
              this.goodsModel = false
            }
          })
      } else {
        this.$toast('请先选择商品规格')
      }
    }
  },
  created() {
    this.goodsId = this.defaultObj.skuId
    this.cartIsHeid()
    this.getCartList()
  },
  mounted() {}
}
</script>
<style lang="stylus" scoped>
.shareImg {
  width: 298px;
  height: 462px;
}

.darkBG {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: rgba(0, 0, 0, 0.8);
}

.goods-container .goods-message {
  background: #ffffff;
  margin-bottom: 10px;
  clear: both;
  overflow: hidden;
}

.count-box {
  height: 100px;
  position: relative;
  padding: 0 15px;
  border-bottom: 1px solid #ebedf0;
}

.count-x {
  position: absolute;
  right: 0px;
  top: 0px;
  font-size: 20px;
  width: 30px;
  height: 30px;
  background: #ccc;
  text-align: center;
  line-height: 30px;
}

.count-left {
  width: 180px;
  display: inline-block;
  margin-top: 40px;
}

.count-box .num-count {
  position: absolute;
  right: 15px;
  top: 53px;
  width: 150px;
  text-align: right;
}

.count-box .change-count {
  color: #333;
  font-size: 14px;
  font-weight: 600;
  margin-right: 10px;
}

.color-999 {
  color: #999;
  font-size: 12px;
  margin-top: 2px;
}

.module-btn-white {
  background: #FFEDE6;
  color: #FC4C00 !important;
}

.collageflex {
  display: flex;
  flex-direction: column;
  justify-content: center;

  .nostardiv {
    font-size: 10px;
    line-height: 11px;
    text-align: center;
    color: #FFFFFF;
    opacity: 0.7;
  }

  .normalPay {
    margin-top: 6px;
    font-weight: 500;
    font-size: 16px;
    line-height: 17px;
    text-align: center;
    color: #FFFFFF;
  }
}

>>>.vip-buy--pop {
  background: rgba(0, 0, 0, 0) url('~@/assets/vip-buy/tips-pop.png') no-repeat center;
  background-size: cover;
  width: 335px;
  height: 213px;
  padding-top: 94px;
  text-align: center;

  .title {
    font-size: 18px;
    font-weight: bold;
    color: #333333;
  }

  .content {
    font-size: 16px;
    line-height: 22px;
    color: #666666;
    padding: 20px 0;

    span {
      color: #FC4C00;
    }
  }

  .prompt-text {
    font-size: 12px;
    line-height: 20px;
    color: #666;
    padding-bottom: 20px;

    .icon {
      margin-left: 5px;
      color: #FC4C00;
    }
  }

  .button {
    width: 295px;
    height: 44px;
    line-height: 44px;
    border-radius: 44px;
    color: #ffffff;
    font-size: 16px;
    text-align: center;
    background: #FC4C00;
    margin: 0 auto;
  }
}

.footer {
  position: fixed;
  bottom: 0;
  z-index: 999;
  width: 100%;
  background: #ffffff;
  color: #7d7e80;
}

.module-nav {
  display: flex;
  text-align: center;
  justify-content: middle;
  align-items: center;
  height: 54px;
  border-top: 1px solid #E5E5E5;
  box-sizing: border-box;
}

.module-nav .server {
  flex: 1;
  font-size: 0;
  position: relative;
}

.server .font {
  color: #666666;
  font-size: 12px;
  display: block;
}

.server .icon {
  font-size: 23px;
}

.module-btn {
  flex: 2;
  height: 54px;
  line-height: 54px;
  font-size: 16px;
  color: #ffffff;
}

.module-btn--grey {
  background: #ccc;
  color: #333;
}

.join-car {
  background: #FFAF00;
}

.get-buy {
  background: #FC4C00;
}

.num-tag {
  position: absolute;
  right: 5px;
  top: -10px;
  width: 23px;
  height: 23px;
  line-height: 24px;
  border-radius: 50% 50%;
  background: #FD4E00;
  color: #fff;
  font-size: 12px;
  font-style: normal;
}

.nums {
  position: absolute;
  right: 5px;
  top: -10px;
  color: #FD4E00;
  font-size: 12px;
  font-style: normal;
}

.goodsModel {
  margin: 20px 12px 0 12px;

  .imgMsgs {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .image {
      width: 104px;
      height: 104px;
      margin-right: 14px;
    }

    .rightPrice {
      width: 225px;

      .red {
        color: #FA6400;
        font-size: 18px;
        font-weight: bold;
      }

      .p {
        font-size: 12px;
        color: #999999;
        margin-top: 4px;
      }
    }
  }
}

.change-num {
  padding: 12px 0;
  line-height: 26px;
  margin: 5px 16px 20px;

  .label {
    float: left;
    font-size: 14px;
    color: #333;
  }

  .text {
    float: left;
    font-size: 12px;
    color: #999;
    padding-left: 10px;
  }

  .goods-stepper {
    float: right;
  }
}

.btns {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 20px;

  .buyNowBtn {
    width: 170px;
    margin: 0 6px;

    &.xuni {
      width: 343px;
    }
  }
}

.buyNowBtn {
  margin: 0 16px;
  width: 343px;
  height: 40px;
  line-height: 40px;
  color: #fff;
  font-size: 12px;
  background: #FC4C00;
  border-radius: 40px;
  text-align: center;

  &.disabled {
    margin-bottom: 20px;
    background: #c5c5c5;
  }
}
</style>
<style scoped>
.product_tab {
  overflow-y: auto;
  padding: 0 16px;
}
.product_tab .tab_specs {
  margin-top: 12px;
}
.product_tab .tab_specs .title {
  margin-bottom: 0;
  font-size: 14px;
  color: #333333;
}
.product_tab .tab_specs .list .view {
  display: inline-block;
}
.product_tab .tab_specs .list .text {
  display: inline-block;
  height: 26px;
  line-height: 26px;
  padding: 0 25px;
  background: #f2f2f2;
  border-radius: 15px;
  font-size: 12px;
  margin: 10px 8px 10px 0;
}
.product_tab .tab_specs .list .active .text {
  border: 1rpx solid #bf1e2b;
  background: #f4e6e8;
  color: #bf1e2b;
}
.product_tab .tab_specs .list .active .text.none {
  color: #666;
  border: 1px solid #bf1e2b;
}
</style>
